import React from 'react';
import { Masterclass } from './components/Masterclass';
export function App() {
  return <div className="bg-black text-white font-sans selection:bg-brand-orange selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Masterclass data-id="element-2" />
      </main>
    </div>;
}